import React from 'react';
import Button from 'shared/components/button/Button';

class TimelineLoad extends React.Component {
  render() {
    return (
      <div className="timeline-load">
        <Button
          id=""
          type=""
          btnBlock=""
          btnSize=""
          color="secondary"
          label="Load More"
          onClick={this.props.handleLoadMore}
        />
      </div>
    );
  }
}

export default TimelineLoad;
